import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ToolButton } from "ui/Scripts/source/components/framework/toolButton";

interface ILockedToOtherUserProps {
    isLockedToOtherUser: boolean;
    userIsIsSystemAdmin: boolean;
    lockedUserPicture: string;
    lockedUserName: string;
    onUnlockClick: () => void;
}

export const LockedToOtherUser = (props: ILockedToOtherUserProps) => {
    if (!props.isLockedToOtherUser) return null;

    return (
        <div className="row lockedRow">
            <div className="col-12">
                <div className="fullLeft form-group">
                    <div>
                        <label className="control-label">{Translations.LockedToUser}</label>
                        {props.userIsIsSystemAdmin &&
                            <ToolButton
                                tooltip={Translations.Unlock}
                                classes={"unlock round mono right"}
                                onClick={props.onUnlockClick}
                            />
                        }
                    </div>
                    <div>
                        <div className="iconCont">
                            {!!props.lockedUserPicture &&
                                <img alt="..." src={props.lockedUserPicture} />
                            }
                        </div>
                        <div className="dataCont withToolButton">
                            <div className="singleLine">{props.lockedUserName}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
